import { apiSlice } from 'store/api/apiSlice';

export const initialAPISlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTenantById: builder.query({
      query: ({ brandId }) => ({
        url: `/tenant/public?id=${brandId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getBranchById: builder.query({
      query: ({ branchId }) => ({
        url: `/branch/public?id=${branchId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getTableStatusByBranchIdAndTableId: builder.query({
      query: ({ brandId, branchId, tableId }) => ({
        url: `/order/public/get-table-order?tenantId=${brandId}&branchId=${branchId}&tableId=${tableId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getStoreDataByBranchId: builder.query({
      query: ({ branchId }) => ({
        url: `/branchSetting/public/general-setting/${branchId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});
export const {
  useGetTenantByIdQuery,
  useGetBranchByIdQuery,
  useGetTableStatusByBranchIdAndTableIdQuery,
  useGetStoreDataByBranchIdQuery,
} = initialAPISlice;
